// ----------------------------------------------------------------------

import { useCallback, useState } from "react";
import axios from "src/utils/axios";
import { IChatRequest, IChatResponse } from "src/@types/aiChat";

// Send chat message
export function useAIChatMessage() {
  const [loading, setLoading] = useState(false);

  const sendChatMessage = useCallback(
    async (body: IChatRequest): Promise<IChatResponse> => {
      setLoading(true);

      try {
        const response = await axios.post("/chat/message", body);
        return response.data;
      } catch (error) {
        throw error;
      } finally {
        setLoading(false);
      }
    },
    []
  );

  return { sendChatMessage, loading };
}

// Apply interest to activate AI assistant (existing hook reference)
export function useAIAssistantInterest() {
  const applyAIAssistantInterest = useCallback(
    async () =>
      axios
        .post(`/assets/vehicles/interestAi`)
        .then((res) => res.data)
        .catch((e) => {
          throw e;
        }),
    []
  );

  return { applyAIAssistantInterest };
}
